export default {
  listTitleTable: {
    TICKER: 'MÃ',
    RTD11: 'VỐN HÓA',
    ISA3: 'DOANH THU (Tỷ)<br><small>(TTM)</small>',
    ISA20: 'LỢI NHUẬN (Tỷ)<br><small>(TTM)</small>',
    //FRYQ30: 'LỢI NHUẬN (Tỷ)<br><small>(Dự phóng)</small>',
    ISA22: 'LỢI NHUẬN (Tỷ)<br> <small>(Kế Hoạch)</small>',
    RTD21: 'P/E',
    RTD54: 'P/E DỰ BÁO ',
    RTD14: 'EPS<br><small>(TTM)</small>',
    RTD53: 'EPS DỰ BÁO',
    RTD7: 'BVPS<br><small>(TTM)</small>',
  },
};
